// import { getLoggedInUser } from '../../../shared/helpers/authUtils';
import { authService } from '../../../modules/users/services/dependency.injection';
import { SET_AUTH_ERROR, SET_AUTH_SUCCESS } from './actionType';

const initialState = {
    userInfo: authService.getLoggedInUser(),
    authError: '',
    authSuccess: ''
};

const login = (state = initialState, action) => {
    switch (action.type) {
        case SET_AUTH_ERROR:
            state = { ...state, authError: action.payload };
            break;
        case SET_AUTH_SUCCESS:
            state = { ...state, authSuccess: action.payload };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default login;
